import moment from 'moment';//moment 时间格式处理插件
import BigNumber from 'bignumber.js';
// import { Message, Loading } from 'element-ui';
let axios = require('axios');
function install(Vue){
    //axios 不带消息提示
    Vue.prototype.postGet = function(url,data,successFunc,errorFunc,wrongFunc){
        axios.get(url,data).then(response=>{
            if(response.status==200){
                if(response.data.code=="0"){
                    if(successFunc){
                        successFunc(response)
                    }
                }else if(response.data.code==2000||
                    Number(response.data.code) === 3000){
                    this.$router.replace("/login");
                }else{
                    if(errorFunc){
                        errorFunc(response)
                    }
                }
            }
        }).catch(error=>{
            if(wrongFunc){
                wrongFunc(error)
            }
        })
    }
    //通用列表请求 列设置，拖拽，宽度设置，返回函数
    Vue.prototype.$postColumnList = function (url,params,successFunc,errorFunc,wrongFunc) {
        this.tableLoading = true;
        let _params = this.$cloneJson(params);
        axios.post(url,_params).then(res=>{
            if(Number(res.status)===200){
                if(String(res.data.code)==="0"){
                    // this.$refs.pagination.flag = true;
                    // this.tableLoading = false;
                    let origin=res;
                    let resD = origin;
                    // this.total = resD.total;
                    // this.last_page = resD.last_page;
                    // this.per_page = resD.per_page;
                    // this.tableData = resD.data;
                    this.filter = origin.data.data.column;
                    // // this.tot = resD.total;
                    // // this.info = resD.info;
                    let tableCol = [];
                    let resFields = resD.data.data.fields;
                    resFields.forEach((field) => {
                        let originConf = this.tableColCopy.find(a => a.colKey === field);
                        if (originConf) {
                            originConf = this.$deepClone(originConf);
                            originConf.isShow = true;
                            originConf.colWidth = this.filter.find(a => a.field === field).width;
                            tableCol.push(originConf);
                        }
                    });
                    this.tableCol = tableCol;
                    let rawFields = this.tableColCopy.map(a => a.colKey);
                    //特殊处理 追加的显示详情列
                    let appendField = 'see_detail_append';//追加的字段详情
                    if (rawFields.includes(appendField) && !resFields.includes(appendField)) {
                        let appendCol = this.tableColCopy.find(a=>a.colKey===appendField);
                        this.tableCol.push(appendCol);
                    }
                    
                    if(successFunc){
                        successFunc(resD, origin);
                    }
                }else if(Number(res.data.code)===2000||
                Number(response.data.code) === 3000){
                    this.$redirectToLogin();
                }else{
                    if(errorFunc){
                        errorFunc(res);
                    }
                    this.tip(res.data.message, "warning");
                }
            }
        }).catch(error=>{
            if(wrongFunc){
                wrongFunc(error);
                this.tip(error.data.message, "warning");
            }
        })
    };
    //axios 不带消息提示
    Vue.prototype.postFunc = function (url, data, successFunc, errorFunc, wrongFunc) {
        axios.post(url, data).then(response => {
            if (response.status == 200) {
                if (response.data.code == "0") {
                    if (successFunc) {
                        successFunc(response)
                    }
                } else if (response.data.code == 2000||
                    Number(response.data.code) === 3000) {
                    this.$router.replace("/login");
                } else {
                    if (errorFunc) {
                        errorFunc(response)
                    }
                }
            }
        }).catch(error => {
            if (wrongFunc) {
                wrongFunc(error)
                this.tip(error.data.message,"warning")
            }
        })
    };
    /*本地请求接口---测试用*/
    Vue.prototype.$postLoc = function (url, data, successFunc, errorFunc, wrongFunc) {
        window.localAxios.post(url, data).then(response => {
            if (Number(response.status) === 200) {
                let code = Number(response.data.code);
                if (code === 0) {
                    successFunc && successFunc(response);
                } else if (code === 2000||
                    Number(response.data.code) === 3000) {
                    this.$router.replace("/login");
                } else {
                    errorFunc && errorFunc(response);
                }
            }
        }).catch(error => {
                wrongFunc && wrongFunc(error);
        })
    };
    //axios 不带消息提示
    Vue.prototype.postFuncLoading = function(url,data,successFunc,errorFunc,wrongFunc){
        const loading = this.$loading({
            lock: true,//lock的修改符--默认是false
            text: 'Loading',//显示在加载图标下方的加载文案
            spinner: 'el-icon-loading',//自定义加载图标类名
            background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
            target: document.querySelector('#table')//loadin覆盖的dom元素节点
        })
        axios.post(url,data).then(response=>{
            loading.close()
            if(response.status==200){
                if(response.data.code=="0"){
                    if(successFunc){
                        successFunc(response)
                    }
                }else if(response.data.code==2000 ||
                    Number(response.data.code) === 3000){
                    this.$router.replace("/login");
                }else{
                    if(errorFunc){
                        errorFunc(response)
                    }
                }
            }
        }).catch(error=>{
            loading.close()
            if(wrongFunc){
                wrongFunc(error)
                this.tip(error.data.message,"warning")
            }
        })
    }
    Vue.directive('dialogDrag', {
        bind (el) {
            // 备注：可以改变类名使其它元素也实现拖拽效果
            // 鼠标点击拖拽区域
            const dialogHeaderEl = el.querySelector('.el-dialog__header')
            // 被拖拽元素主题
            const dragDom = el.querySelector('.el-dialog')
            dialogHeaderEl.style.cursor = 'move'
        
            // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
            const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)
        
            dialogHeaderEl.onmousedown = (e) => {
              // 鼠标按下，计算当前元素距离可视区的距离
              const disX = e.clientX - dialogHeaderEl.offsetLeft
              const disY = e.clientY - dialogHeaderEl.offsetTop
        
              const screenWidth = document.body.clientWidth // body当前宽度
              const screenHeight = document.documentElement.clientHeight // 可见区域高度(应为body高度，可某些环境下无法获取)
        
              const dragDomWidth = dragDom.offsetWidth // 对话框宽度
              const dragDomheight = dragDom.offsetHeight // 对话框高度
        
              const minDragDomLeft = dragDom.offsetLeft-100
              const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth
        
              const minDragDomTop = dragDom.offsetTop-90
              const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight
        
              // 获取到的值带px 正则匹配替换
              let styL, styT
        
              // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
              if (sty.left.includes('%')) {
                // eslint-disable-next-line no-useless-escape
                styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
                // eslint-disable-next-line no-useless-escape
                styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
              } else {
                styL = +sty.left.split('px')[0]
                styT = +sty.top.split('px')[0]
              }
        
              document.onmousemove = function (e) {
                // 通过事件委托，计算移动的距离
                let left = e.clientX - disX
                let top = e.clientY - disY
        
                // 边界处理
                if (-(left) > minDragDomLeft) {
                  left = -(minDragDomLeft)
                } else if (left > maxDragDomLeft) {
                  left = maxDragDomLeft
                }
        
                if (-(top) > minDragDomTop) {
                  top = -(minDragDomTop)
                } else if (top > maxDragDomTop) {
                  top = maxDragDomTop
                }
        
                // 移动当前元素
                dragDom.style.transform = 'none'
                dragDom.style.left = `${left + styL}px`
                dragDom.style.top = `${top + styT}px`
        
                // 将此时的位置传出去
                // binding.value({x:e.pageX,y:e.pageY})
              }
        
              document.onmouseup = function () {
                document.onmousemove = null
                document.onmouseup = null
              }
            }
          }
    })
    Vue.directive('twoDecimal', {
        bind: function(el,bind) {
            el.addEventListener('input', function(e) {
                e = e || window.event;
                let val = e.target.value
                if(val.lastIndexOf(".")!=-1){
                    let digitOther = val.length - (val.lastIndexOf(".")+1) - 2
                    if(digitOther > 0){
                        e.target.value = val.substring(0,val.length - digitOther)
                    }
                }
            })
        }
    }) 
    Vue.prototype.pagesetup_null = function(){
        try{
            var RegWsh = new ActiveXObject("WScript.Shell");
            hkey_key="header";    
            RegWsh.RegWrite(hkey_root+hkey_path+hkey_key,"");
            hkey_key="footer";
            RegWsh.RegWrite(hkey_root+hkey_path+hkey_key,"");
        }catch(e){ alert(e); }
    }
    Vue.prototype.pagesetup_default = function(){
        try{
            var RegWsh = new ActiveXObject("WScript.Shell");
            hkey_key="header";    
            RegWsh.RegWrite(hkey_root+hkey_path+hkey_key,"&w&b页码，&p/&P");
            hkey_key="footer";
            RegWsh.RegWrite(hkey_root+hkey_path+hkey_key,"&u&b&d");
        }catch(e){ alert(e); }
    }
    Vue.prototype.setLocalStorge = function(response){
        localStorage.setItem("dw_erp_user_id",response.data.data.id);
        localStorage.setItem("dw_erp_user_company_id",response.data.data.company_id);
        localStorage.setItem("dw_erp_user_name",response.data.data.name);
        localStorage.setItem("dw_erp_is_super",response.data.data.is_super);
        localStorage.setItem("dw_erp_user_username",response.data.data.username);
        localStorage.setItem("dw_erp_all_customer",response.data.data.all_customer);//created by xiong 客户权限
        localStorage.setItem("dw_erp_all_fee",response.data.data.all_fee);//created by xiong 费用权限
        localStorage.setItem("dw_erp_user_token",response.data.data.token);
        localStorage.setItem("dw_erp_power_code",","+(response.data.data.modules.join(",")).toString()+",");
        localStorage.setItem("dw_erp_company_name",response.data.data.company_name);
        localStorage.setItem("dw_erp_union_company",JSON.stringify(response.data.data.union_company));
        localStorage.setItem("dw_erp_category",(response.data.data.category.join(",")).toString());
        localStorage.setItem("dw_erp_board",(response.data.data.board.join(",")).toString());
        localStorage.setItem("dw_erp_enable_config",(response.data.data.enable_config.join(",")).toString());
        // localStorage.setItem("dw_erp_full_company_name",response.data.data.full_name);
        let qimName=localStorage.dw_erp_user_name+"("+localStorage.dw_erp_company_name+")";
        window.qimoClientId = {
            userId: localStorage.dw_erp_user_id, // 自定义用户的唯一id，不能传空字符串、null、中文，id由字母大小写、数字及'-'和 '_'组成
            priority: false, //是否优先进线设置，非必填，值为boolean类型的true或false
            nickName: qimName,//自定义用户昵称，定义用户昵称则userId必传
        };
        this.$router.replace("/index").catch(err=>{
            console.log(err,9999991)
        });
    }
    Vue.prototype.removeLocalStorge = function(){
        localStorage.removeItem("dw_erp_user_id");
        localStorage.removeItem("dw_erp_user_company_id");
        localStorage.removeItem("dw_erp_user_name");
        localStorage.removeItem("dw_erp_is_super");
        localStorage.removeItem("dw_erp_user_username");
        localStorage.removeItem("dw_erp_all_customer");//added by xiong 超级管理员权限
        localStorage.removeItem("dw_erp_user_token");
        localStorage.removeItem("dw_erp_power_code");
        localStorage.removeItem("dw_erp_company_name");
        localStorage.removeItem("dw_erp_category");
        localStorage.removeItem("dw_erp_board");
        localStorage.removeItem("dw_erp_enable_config");
        this.$router.replace("/login");
    }
    Vue.prototype.removeLocalStorges = function(){
        localStorage.removeItem("dw_erp_user_id");
        localStorage.removeItem("dw_erp_user_company_id");
        localStorage.removeItem("dw_erp_user_name");
        localStorage.removeItem("dw_erp_is_super");
        localStorage.removeItem("dw_erp_user_username");
        localStorage.removeItem("dw_erp_all_customer");//added by xiong 超级管理员权限
        localStorage.removeItem("dw_erp_user_token");
        localStorage.removeItem("dw_erp_power_code");
        localStorage.removeItem("dw_erp_company_name");
        localStorage.removeItem("dw_erp_category");
        localStorage.removeItem("dw_erp_board");
        localStorage.removeItem("dw_erp_enable_config");
        // this.$router.replace("/login");
    }
    Vue.prototype.accuracy = function(arg1,arg2){
        var r1,r2,m,n;
        try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
        try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
        m=Math.pow(10,Math.max(r1,r2));
        //last modify by deeka
        //动态控制精度长度
        n=(r1>=r2)?r1:r2;
        return ((arg1*m+arg2*m)/m).toFixed(n);
    }
    Vue.prototype.formatTimeZero = function(time){
        if(time){
            return parseInt((moment(time).valueOf())/1000)
        }else{
            return "";
        }
    }
    Vue.prototype.calcu = function(numberA,numberB,type,func,keep){
        try{
            if((!!Number(numberA)||numberA==0)&&(!!Number(numberB)||numberB==0)){
                // let numA = Math.floor(numberA * 10000);
                // let numB = Math.floor(numberB * 10000);
                let lengthA = (numberA + "").length;
                let lengthB = (numberB + "").length;
                let ditA = (numberA + "").indexOf(".")==-1?0:(numberA + "").indexOf(".");
                let ditB = (numberB + "").indexOf(".")==-1?0:(numberB + "").indexOf(".");
                let numA = 0;
                let numB = 0;
                let repair = 0;
                let digitA = ditA == 0 ? 0 : (lengthA - 1) - ditA;
                let digitB = ditB == 0 ? 0 : (lengthB - 1) - ditB;
                if(digitA == 0 && digitB == 0){
                    numA = numberA;
                    numB = numberB;
                }else{
                    numA = (numberA + "").replace(".","");
                    numB = (numberB + "").replace(".","");
                    if(digitA - digitB == 0){
                        repair = digitA;
                    }else if(digitA - digitB < 0){
                        repair = digitB;
                        numA = numA + "0".repeat(Math.abs(digitA - digitB))
                    }else if(digitA - digitB > 0){
                        repair = digitA;
                        numB = numB + "0".repeat(Math.abs(digitA - digitB))
                    }
                }
                let val = 0;
                if(type == "add"){
                    // val = (numA + numB) / 100;
                    // val = Math.floor(val) /100;
                    val = Number(numA) + Number(numB);
                }else if(type == "reduce"){
                    // val = (numA - numB) / 100;
                    // val = Math.floor(val) /100;
                    val = Number(numA) - Number(numB);
                }else if(type == "mul"){
                    // val = (numA * numB) / 1000000;
                    // val = Math.floor(val) /100;
                    val = Number(numA) * Number(numB);
                    repair = repair * 2;
                }else if(type == "div"){
                    val = Number(numA) / Number(numB);
                }else{
                    this.tip("type类型错误","warning")
                    func(0)
                    return;
                }
                if(func){
                    val = val.toString();
                    keep = keep ? keep : 2;
                    if(type == "div"){
                        if(val.indexOf(".")!=-1){
                            val = val.substring(0,val.indexOf(".") + keep)
                            val = Number(val)
                        }else{
                            val = Number(val)
                        }
                    }else{
                        if(val.length <= repair){
                            let repNum = val.length-repair;
                            repNum = repNum < 0 ? 0 : repNum;
                            val = "0."+"0".repeat(repNum) + val;
                        }else{
                            val = val.slice(0,val.length-repair) + '.' + val.slice(val.length-repair);
                        }
                        val = val.substring(0,val.length - (repair-keep))
                        val = Number(val)
                    }
                    val = val.toFixed(keep)
                    val = Number(val)
                    func(val)
                }
                // return Number()
            }else{
                this.tip("请输入数字","warning")
                func(0)
            }
        }catch(e){
            this.pl(e)
        }
    }
    Vue.prototype.keepLimit = function(number){
        if (Number(number) || Number(number) === 0) {
            // return Math.floor(Number(number) * 10000) / 10000
            // return Number(parseFloat(number).toFixed(4))
            // return this.numberAccurate(Math.floor(Number(number) * 10000) / 10000)
            return this.numberAccurateLimit(parseFloat(number));
            // return(Math.round(number * 10000) / 10000).toFixed(4)
            // return this.$keepNumber(number, num);
        }
    }
    Vue.prototype.keepLimitNum = function(number){
        let num = localStorage.getItem('dm_erp_decimal_scale');
        if (Number(number) || Number(number) === 0) {
            // return this.$keepNumber(number, num);
            const precision = 14
            return Number(parseFloat(window.mathFormat.format(number, precision)).toFixed(num))
        }
    }
    Vue.prototype.keepPrice = function(number){
        if(Number(number)||Number(number)===0){
            return this.$keepNumber(number, 2);
            // return Math.floor(Number(number) * 100) / 100
            // return Number(parseFloat(number).toFixed(2))
            // this.pl("in")
            // this.pl(number)
            // this.pl(this.numberAccurate(Number(number)))
            // return this.numberAccurate(parseFloat(number))
            // return Math.floor(this.numberAccurate(parseFloat(number)) * 100) / 100
            // return Math.floor(parseFloat(number) * 100) / 100
        }
    }
    //保留2位
    Vue.prototype.keepPrices = function (number) {
        let decimalPlaces = 2; // 要保留的小数位数
        return +(Math.round(number + `e+${decimalPlaces}`)  + `e-${decimalPlaces}`);

        // let p = Math.pow(10, 2);
        // let value = number * p;
        // let roundedValue = (number > 0) ? Math.ceil(value - 0.5) : Math.floor(value + 0.5);
        // return roundedValue / p;
        
        // let val = 0.33335;
        // let roundedVal = customRound(val, 4);
        // console.log(roundedVal); // 输出: 0.3334

        // console.log(Math.round(80262.525 * 100) / 100)
        // console.log(Math.round(80262.525*100)/100,444)
        // console.log(Math.ceil(80262.525 * Math.pow(10, 2)) / Math.pow(10, 2),111)
        // console.log(Math.round(80262.525*Math.pow(10, 2)) / Math.pow(10, 2),222)
        // return Math.round(number*Math.ceil(10, 2)) / Math.pow(10, 2);
        // return Math.ceil(number * Math.pow(10, 2)) / Math.pow(10, 2);
        // console.log(this.$keepNumber(80262.526, 2),111)
        // return (Math.round(Number(number) * 100) / 100).toFixed(2);//四舍五入
        // return this.$keepNumber(number, 2);
    };
    //四合五入保留两位金额
    Vue.prototype.newKeepPrice = function(number){
        const multiplier = Math.pow(10, 2);
        const roundedNumber = Math.round(number * multiplier) / multiplier;
        // 将小数部分提取出来，判断最后一位是否为5
        const decimalPart = roundedNumber - Math.floor(roundedNumber);
        const lastDecimal = Math.floor(decimalPart * 10);
        // 如果最后一位是5，则进位
        if (lastDecimal === 5) {
          return (Math.ceil(roundedNumber * multiplier) + 1) / multiplier;
        }
        return roundedNumber;
    },
    //取整
    Vue.prototype.rounding = function (val) {
        return Math.round(Number(val));//四舍五入
    };
    Vue.prototype.numberAccurate = function(value) {
        const precision = 14
        // return Number(parseFloat(window.mathFormat.format(value, precision)).toFixed(2))
        return Number(Math.floor(parseFloat(window.mathFormat.format(value, precision))*100)/100)
    }
    Vue.prototype.numberAccurateLimit = function(value) {
        const precision = 14
        return Number(parseFloat(window.mathFormat.format(value, precision)).toFixed(4))
    }
    Vue.prototype.getDownloadTempleteTime = function(time){
        let date = new Date(time);
        return date.getFullYear()+""+((date.getMonth()+1)<10?('0'+(date.getMonth()+1)):(date.getMonth()+1))+""+(date.getDate()<10?'0'+date.getDate():date.getDate())+""+date.getHours()+""+(date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes());
    }
    Vue.prototype.formatTime = function(inputTime){
        var date = new Date(parseInt(inputTime));
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        // var h = date.getHours();
        // h = h < 10 ? ('0' + h) : h;
        // var minute = date.getMinutes();
        // var second = date.getSeconds();
        // minute = minute < 10 ? ('0' + minute) : minute;
        // second = second < 10 ? ('0' + second) : second;
        // return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
        return y + '-' + m + '-' + d;
    }
    Vue.prototype.formatTimeMonth = function(inputTime){
        var date = new Date(parseInt(inputTime));
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        // var h = date.getHours();
        // h = h < 10 ? ('0' + h) : h;
        // var minute = date.getMinutes();
        // var second = date.getSeconds();
        // minute = minute < 10 ? ('0' + minute) : minute;
        // second = second < 10 ? ('0' + second) : second;
        // return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
        return y + '-' + m;
    }
    Vue.prototype.formatTimeSecond = function(inputTime){
        var date = new Date(parseInt(inputTime));
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
    }
    Vue.prototype.monthFirstDay = function(){
        let date = new Date();
        // date.setMonth(month)
        date.setDate(1);
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setUTCMilliseconds(0)
        return date
    }

    Vue.prototype.getArea = function(id){
        return new Promise((resolve)=>{
            axios.post("/erp/area.code.select",{pid:id}).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            })
        })
    }
    Vue.prototype.tip = function(message,type){
        this.$message({message:message,type:type,dangerouslyUseHTMLString: true})
    }
    Vue.prototype.resetJson = function(json){
        for(let js in json){
            json[js]="";
        }
        return json;
    }
    Vue.prototype.clearZero = function(json){
        for(let js in json){
            if(json[js]==0&&js.indexOf("status")==-1){
                json[js]="";
            }
        }
        return json;
    }
    Vue.prototype.resetSearch = function(json){
        for(let js in json){
            if(js!="page"&&js!="per_page"){
                json[js]="";
            }
        }
        return json;
    }
    //下拉列表获取数据
    Vue.prototype.$getSelectList = function(target,obj){
        let url;
        switch(target){
            case "creater":
                url = "/erp/purchase.creators";
            break;
            case "breed":
                url = "/erp/breed.select";
            break;
            case "brand":
                url = "/erp/brand.select";
            break;
            case "grade":
                url = "/erp/grade.select";
            break;
            case "warehouse":
                url = "/erp/warehouse.select";
            break;
            case "port":
                url = "/erp/port.select";
            break;
            case "currency":
                url = "/erp/currency.select";
            break;
            case "feeType":
                url = "/erp/fee.type.select";
            break;
            case "paymentType":
                url = "/erp/payment.type.select";
            break;
            case "account":
                url = "/erp/account.select";
            break;
            case "supplier":
                url = "/erp/supplier.select";
            break;
            case "customerAttribute":
                url = "/erp/customer.attribute.select";
            break;
            case "customerSource":
                url = "/erp/customer.source.select";
            break;
            case "customer":
                url = "/erp/customer.select";
            break;
            case "inventoryoutCustomer":
                url = "/erp/inventoryout.custom.options";
            break;
            case "user":
                url = "/erp/user.select";
            break;
            case "disabledUser":
                url = "/erp/user.select";
            break;
            case "salesmanUser":
                url = "/erp/out.salesman.select";
            break;
            case "purchaseCost":
                url = "/erp/purchase.cost.type";
            break;
            case "lockLevel":
                url = "/erp/lock.level.select";
            break;
            case "operationType":
                url = "/erp/system.operate.type";
            break;
            case "mach":
                url = "/erp/plant.select";
            break;
            case "servers":
                url = "/erp/fee.servers";
            break;
            case "plant":
                url = "/erp/plant.select";
            break;
            case "color":
                url = "/erp/color.select";
            break;
            case "attribute":
                url = "/erp/attribute.select";
            break;
            case "opencompany":
                url = "/erp/opening.company.select";
            break;
            case "saleBreed":
                url = "/erp/sales.breed.select";
            break;
            case "saleTemplate":
                url = "/erp/print.template.get";
            break;
            case "location":
                url = "erp/warehouse.location.select";
            break;
            case "creator":
                url="/erp/move.creator.option";
            break;
            case "transfer":
                url="/erp/move.transfer.option";
            break;
            case "inwarehouse":
                url="/erp/move.inwarehouse.option";
            break;
            case "outwarehouse":
                url="/erp/move.outwarehouse.option";
            break;
            case "translate":
                url="/erp/translate.option.transfer";
            break;
            case "billCustomer":
                url="/erp/bill.customer.select";
            break;
            case "options":
                url="/erp/order.status.options";
            break;
            case "linkman":
                url="/erp/issuing.linkman.select";
            break;
            case "payerList":
                url="/erp/payer.select";
            break;
            case "payer":
                url="/erp/purchase.payer.select";
            break;
            case "pledgeissuing":
                url="/erp/pledge.issuing.select";
            break;
            case "pledgestatus":
                url="/erp/pledge.status.select";
            break;
            case "redeemissuing":
                url="/erp/redeem.issuing.select";
            break;
            case "loadmissuing":
                url="/erp/redeem.load.issuing.select";
            break;
            case "redeemstatus":
                url="/erp/redeem.status.select";
            break;
            case "redeemsales":
                url="/erp/redeem.sales.status.select";
            break;
            case "advissuing":
                url="/erp/redeem.adv.issuing.select";
            break;
            case "advstatus":
                url="/erp/redeem.adv.status.select";
            break;
            case "issuing":
                url="/erp/issuing.select";
            break;
            case "inventoryissuing":
                url="/erp/inventory.issuing.select";
            break;
            case "customerSelect":
                url="/erp/finance.order.customer.select";
            break;
            case "brokers":
                url="/erp/custom.brokers.list";
            break;
            case "pledgePurchase":
                url="/erp/pledge.purchase.option";
            break;
            case "redeemBillIssuing":
                url="/erp/redeem.bill.issuing.select";
            break;
            case "redeemBillType":
                url="/erp/redeem.bill.type.select";
            break;
            case "redeemBillOrder":
                url="/erp/redeem.bill.order.select";
            break;
            case "redeemBillPayer":
                url="/erp/redeem.bill.payer.select";
            break;
            case "redeemContract":
                url="/erp/redeem.contract.status.select";
            break;
            case "redeemConIssuing":
                url="/erp/redeem.contract.issuing.select";
            break;
            case "officeTypes":
                url="/erp/office.types.select";
            break;
            case "officeUsers":
                url="/erp/office.users.select";
            break;
            case "warehouseStatuses":
                url="/erp/warehouse.fee.statuses";
            break;
            case "warehouseTypes":
                url="/erp/warehouse.fee.types";
            break;
            case "assemblyBreed":
                url="/erp/assembly.breed.select";
            break;
            case "translateJgtypeOption":
                url="/erp/translate.package.jgtype.option";//翻包加工类型
            break;
            case "purchaseType":
                url="erp/purchase.sales.type";//数据来源
            break;
            case "settlementType":
                url="/erp/purchase.settlement.type";//合同应付结算类型
            break;
            case "purchaseBillType":
                url="/erp/purchase.bill.type";//应付流水类型
            break;
            case "purchasesalesType":
                url="/erp/purchase.sales.type";//调货单来源类型下拉
            break;
            case "settlementTypeSelect":
                url="/erp/purchase.settlement.select";//调货应付结算状态
            break;
            case "recSelect":
                url="/erp/purchase.rec.select";//调货应付REC下拉
            break;
            case "invoiceSelect":
                url="/erp/purchase.invoice.select";//调货应付发票下拉
            break;
            case "cargoStatus":
                url="/erp/purchase.cargo.status";//板材调货管理资源状态
            break;
            case "purchaseSettlementStatus":
                url="/erp/purchase.settlement.status.options";//调货结算状态
            break;
            case "warehouseFee":
                url="/erp/warehouse.balance.fee.options";//库存结余仓库
            break;
            case "preOrder":
                url="/erp/pre.order.search.options";//预售单下拉
            break;
            case "preStatus":
                url="/erp/pre.order.search.options";//预售单状态
            break;
            case "accountOptions":
                url="/erp/order.account.options";//应收管理 收款账户 
            break;
            case "issuingInterestStatus":
                url="/erp/issuing.interest.status";//开证公司利息状态下拉
            break;
            case "issuingInterestTitle":
                url="/erp/issuing.interest.title";//开证公司利息类目下拉
            break;
        }
        return new Promise((resolve)=>{
            let data = {...obj}
            axios.post(url,data).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        let obj = new Object();
                        obj.target = target;
                        obj.list = response.data.data;
                        resolve(obj)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        }).catch((e) => {});
    }
    //仓库下拉列表获取数据
    Vue.prototype.$getSelectWarehouseList = function(target,param,type,types){
        let condiation = JSON.parse(JSON.stringify(param))
        condiation.target=target;
        if(condiation.length){
            condiation.original_length= [];
            // condiation.length;
        }
        if(condiation.thickness){
            condiation.original_thickness= [];
            // condiation.thickness;
        }
        condiation.wood_type = type;
        condiation.types = types;
        return new Promise((resolve)=>{
            axios.post("/erp/inventory.search.condition",condiation).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    //库存结余
    Vue.prototype.$getInventoryBalanceList = function(target,param){
        let condiation = JSON.parse(JSON.stringify(param))
        condiation.target=target;
        return new Promise((resolve)=>{
            axios.post("/erp/stock.balance.options",condiation).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    //库存结余明细下拉
    Vue.prototype.$getStockDetailList = function(target,param,type){
        let condiation = JSON.parse(JSON.stringify(param))
        condiation.target=target;
        if(condiation.length){
            condiation.original_length= [];
            // condiation.length;
        }
        if(condiation.thickness){
            condiation.original_thickness= [];
            // condiation.thickness;
        }
        condiation.balance_type = type;
        return new Promise((resolve)=>{
            axios.post("/erp/stock.detail.options",condiation).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    //采购订单下拉列表获取数据
    Vue.prototype.$getSelectsalePurchase = function(target,param,type){
        let condiation = JSON.parse(JSON.stringify(param))
        condiation.target=target;
        if(condiation.length){
            condiation.original_length=condiation.length;
        }
        if(condiation.thickness){
            condiation.original_thickness=condiation.thickness;
        }
        condiation.wood_type = type;
        return new Promise((resolve)=>{
            axios.post("/erp/purchase.search.condition",condiation).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    //销售定价下拉列表获取数据
    Vue.prototype.$getSelectsalePricingList = function(target,param,type){
        let condiation = JSON.parse(JSON.stringify(param))
        condiation.target=target;
        if(condiation.length){
            condiation.original_length=condiation.length;
        }
        if(condiation.thickness){
            condiation.original_thickness=condiation.thickness;
        }
        condiation.wood_type = type;
        return new Promise((resolve)=>{
            axios.post("/erp/system.price.select",condiation).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    //成本查看下拉列表获取数据
    Vue.prototype.$getSelectsaleCostSeeList = function(target,param,type){
        let condiation = JSON.parse(JSON.stringify(param))
        condiation.field=target;
        if(condiation.length){
            condiation.original_length=condiation.length;
        }
        if(condiation.thickness){
            condiation.original_thickness=condiation.thickness;
        }
        condiation.wood_type = type;
        return new Promise((resolve)=>{
            axios.post("/erp/inventory.cost.search",condiation).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    //销售定价下拉列表获取数据
    Vue.prototype.$getSelectsalePriceSeeList = function(target,param,type){
        let condiation = JSON.parse(JSON.stringify(param))
        condiation.target=target;
        if(condiation.length){
            condiation.original_length=condiation.length;
        }
        if(condiation.thickness){
            condiation.original_thickness=condiation.thickness;
        }
        condiation.wood_type = type;
        return new Promise((resolve)=>{
            axios.post("/erp/price.search.condition",condiation).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    //云链选择下拉列表获取数据
    Vue.prototype.$getSelectCloudSeeList = function(target,param,type){
        let condiation = JSON.parse(JSON.stringify(param))
        condiation.target=target;
        if(condiation.length){
            condiation.original_length=condiation.length;
        }
        if(condiation.thickness){
            condiation.original_thickness=condiation.thickness;
        }
        condiation.wood_type = type;
        return new Promise((resolve)=>{
            axios.post("/erp/cloud.inventory.select",condiation).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
     //盘点详情选择下拉列表获取数据
     Vue.prototype.$getSelectCheckRecord = function(target,param,type){
        let condiation = JSON.parse(JSON.stringify(param))
        condiation.target=target;
        if(condiation.length){
            condiation.original_length=condiation.length;
        }
        if(condiation.thickness){
            condiation.original_thickness=condiation.thickness;
        }
        condiation.wood_type = type;
        return new Promise((resolve)=>{
            axios.post("/erp/inventory.check.details.search",condiation).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    //OA选择下拉列表获取数据
    Vue.prototype.$getSelectOA = function(target,param,type){
        let condiation = JSON.parse(JSON.stringify(param))
        condiation.target=target;
        if(condiation.length){
            condiation.original_length=condiation.length;
        }
        if(condiation.thickness){
            condiation.original_thickness=condiation.thickness;
        }
        condiation.wood_type = type;
        return new Promise((resolve)=>{
            axios.post("/erp/office.select.option",condiation).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    //翻包下拉列表获取数据
    Vue.prototype.$getSelectTranslateList = function(target,param,type,types){
        let condiation = JSON.parse(JSON.stringify(param))
        condiation.target=target;
        if(condiation.length){
            condiation.original_length= [];
            // condiation.length;
        }
        if(condiation.thickness){
            condiation.original_thickness= [];
            // condiation.thickness;
        }
        condiation.wood_type = type;
        condiation.types = types;
        return new Promise((resolve)=>{
            axios.post("/erp/translate.search.option",condiation).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    //翻包明细下拉列表获取数据
    Vue.prototype.$getSelectTranslateDetailList = function(target,param,type,types){
        let condiation = JSON.parse(JSON.stringify(param))
        condiation.target=target;
        if(condiation.length){
            condiation.original_length= [];
            // condiation.length;
        }
        if(condiation.thickness){
            condiation.original_thickness= [];
            // condiation.thickness;
        }
        condiation.wood_type = type;
        condiation.types = types;
        return new Promise((resolve)=>{
            axios.post("/erp/translate.detail.option",condiation).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    //获取制单人
    Vue.prototype.getCreaterList = function(){
        return new Promise((resolve)=>{
            axios.post("/erp/purchase.creators",{}).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    Vue.prototype.getBreedList = function(){
        return new Promise((resolve)=>{
            axios.post("/erp/breed.select",{}).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    Vue.prototype.getBrandList = function(){
        return new Promise((resolve)=>{
            axios.post("/erp/brand.select",{}).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    Vue.prototype.getGradeList = function(){
        return new Promise((resolve)=>{
            axios.post("/erp/grade.select",{}).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    Vue.prototype.getWarehouseList = function(){
        return new Promise((resolve)=>{
            axios.post("/erp/warehouse.select",{}).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    Vue.prototype.getPortList = function(){
        return new Promise((resolve)=>{
            axios.post("/erp/port.select",{}).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    Vue.prototype.getCurrencyList = function(){
        return new Promise((resolve)=>{
            axios.post("/erp/currency.select",{}).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    Vue.prototype.getPurchaseWareList = function(){
        return new Promise((resolve)=>{
            axios.post("/erp/purchase.warehouse.select",{}).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    Vue.prototype.getFeetypeList = function(){
        return new Promise((resolve)=>{
            axios.post("/erp/fee.type.select",{}).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    Vue.prototype.getPaymenttypeList = function(){
        return new Promise((resolve)=>{
            axios.post("/erp/payment.type.select",{}).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    Vue.prototype.getAccountList = function(){
        return new Promise((resolve)=>{
            axios.post("/erp/account.select",{}).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    Vue.prototype.getSupplierList = function(){
        return new Promise((resolve)=>{
            axios.post("/erp/supplier.select",{}).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    Vue.prototype.getCustomerAttributeList = function(){
        return new Promise((resolve)=>{
            axios.post("/erp/customer.attribute.select",{}).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }
    Vue.prototype.getCustomerSourceList = function(){
        return new Promise((resolve)=>{
            axios.post("/erp/customer.source.select",{}).then(response=>{
                if(response.status==200){
                    if(response.data.code=="0"){
                        resolve(response)
                    }
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        })
    }

    //模板上传单个
    Vue.prototype.analysis = function(url,file,code,purchase_id,processing_id,func){
        const loading = this.$loading({
            lock: true,//lock的修改符--默认是false
            text: 'Loading',//显示在加载图标下方的加载文案
            spinner: 'el-icon-loading',//自定义加载图标类名
            background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
            target: document.querySelector('#table')//loadin覆盖的dom元素节点
        })
        axios.post(url,{
            file : file,
            code : code,
            purchase_id : purchase_id,
            processing_id : processing_id
        }).then(res=>{
                func(res)
                loading.close()
            }
        );
    }
    //模板上传批量
    Vue.prototype.analysisB = function(url,file,code,ids,func){
        const loading = this.$loading({
            lock: true,//lock的修改符--默认是false
            text: 'Loading',//显示在加载图标下方的加载文案
            spinner: 'el-icon-loading',//自定义加载图标类名
            background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
            target: document.querySelector('#table')//loadin覆盖的dom元素节点
        })
        axios.post(url,{
            file : file,
            code : code,
            ids : ids,
        }).then(res=>{
                func(res)
                loading.close()
            }
        );
    }
    //模板上传批量
    Vue.prototype.analysisC = function(url,file,func){
        const loading = this.$loading({
            lock: true,//lock的修改符--默认是false
            text: 'Loading',//显示在加载图标下方的加载文案
            spinner: 'el-icon-loading',//自定义加载图标类名
            background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
            target: document.querySelector('#table')//loadin覆盖的dom元素节点
        })
        axios.post(url,{
            file : file,
            // code : code,
            // ids : ids,
        }).then(res=>{
                func(res)
                loading.close()
            }
        );
    }
     /*获取OSS-部分通用*/
     Vue.prototype.$getOss = function (file) {
        let that = this;
        return new Promise((resolve, reject) => {
            window.axios.post(window.oss_url + "/tool/v1/oss.policy.get", {
                    operate_code: "shop-excel",
                }).then((response) => {
                    if (Number(response.data.code) === 0) {
                        that.oss = response.data.data;
                        that.upload_data = {
                            name: file.name,
                            key: that.oss.dir + "${filename}",
                            policy: that.oss.policy,
                            OSSAccessKeyId: that.oss.accessid,
                            success_action_status: "200",
                            callback: that.oss.callback,
                            signature: that.oss.signature,
                            "Cache-Control": that.oss.cache_control,
                        };
                        resolve();
                    }
                }).catch(() => {
                    reject();
                });
        });
    };
    //判断文件格式是否为图片 (部分图片格式)
    Vue.prototype.$isImgFile = function (fileName) {
        let imgSuffix = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff','ico'];
        let ex1 = new RegExp("(?<=\\.)\\w+$").exec(String(fileName));
        return ex1 && imgSuffix.includes(ex1[0].toLowerCase());
    };
    //除了图片，可以用window.open打开预览的文件，而不直接下载的格式
    Vue.prototype.$isWinpFile = function(fileName) {
        let fileSuffix = ["pdf", "txt", "mp4"];
        let ex1 = new RegExp("(?<=\\.)\\w+$").exec(String(fileName));
        return ex1 && fileSuffix.includes(ex1[0].toLowerCase());
    };
    //导出
    Vue.prototype.$exportExecl = function(url,name,data){
        const loading = this.$loading({
            lock: true,//lock的修改符--默认是false
            text: 'Loading',//显示在加载图标下方的加载文案
            spinner: 'el-icon-loading',//自定义加载图标类名
            background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
            target: document.querySelector('#table')//loadin覆盖的dom元素节点
        })
        this.execlExportFile(url,data).then( (response) => {
            const content = response.data;
            const blob = new Blob([content], {type: response.headers['content-type']});
            const fileName = name+this.getDownloadTempleteTime(new Date())+'.xlsx';
            if ('download' in document.createElement('a')) { // 非IE下载
                const elink = document.createElement('a');
                elink.download = fileName;
                elink.style.display = 'none';
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            } else { // IE10+下载
                navigator.msSaveBlob(blob, fileName);
            }
            loading.close()
        })
    }
    Vue.prototype.execlExportFile = function(url,data){
        return axios.post(url,{
            ...data
        },{responseType: 'arraybuffer'});
    }
    //下载
    Vue.prototype.$backupFile = function(type,func){
        const loading = this.$loading({
            lock: true,//lock的修改符--默认是false
            text: 'Loading',//显示在加载图标下方的加载文案
            spinner: 'el-icon-loading',//自定义加载图标类名
            background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
            target: document.querySelector('#table')//loadin覆盖的dom元素节点
        })
        axios.post("erp/backup.download",{
            time : type,
        },{responseType: 'arraybuffer'}).then(res=>{
            // return
            var arr = res
            var enc = new TextDecoder('utf-8')
            try {
                 var data = JSON.parse(enc.decode(new Uint8Array(arr.data)))
                 loading.close();
                 this.tip(data.message,"warning")
            } catch (error) {
                loading.close();
                func(res)
            }
        },error=>{
            this.tip(error.data.message,"warning")
        });
    }
    //模板下载
    Vue.prototype.exportFile = function(type,contract_no,purchase_id,processing_id,func){
        const loading = this.$loading({
            lock: true,//lock的修改符--默认是false
            text: 'Loading',//显示在加载图标下方的加载文案
            spinner: 'el-icon-loading',//自定义加载图标类名
            background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
            target: document.querySelector('#table')//loadin覆盖的dom元素节点
        })
        axios.post("/erp/down.template",{
            code : type,
            contract_no : contract_no,
            purchase_id : purchase_id,
            processing_id : processing_id
        },{responseType: 'arraybuffer'}).then(res=>{
            // return
            var arr = res
            var enc = new TextDecoder('utf-8')
            try {
                 var data = JSON.parse(enc.decode(new Uint8Array(arr.data)))
                 loading.close();
                 this.tip(data.message,"warning")
            } catch (error) {
                loading.close();
                func(res)
            }
        },error=>{
            this.tip(error.data.message,"warning")
        });
    }
    //翻包模板下载
    Vue.prototype.exportTranslateFile = function(type,func){
        const loading = this.$loading({
            lock: true,//lock的修改符--默认是false
            text: 'Loading',//显示在加载图标下方的加载文案
            spinner: 'el-icon-loading',//自定义加载图标类名
            background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
            target: document.querySelector('#table')//loadin覆盖的dom元素节点
        })
        axios.post("/erp/translate.down.template",{
            code : type,
            // contract_no : contract_no,
            // purchase_id : purchase_id,
            // processing_id : processing_id
        },{responseType: 'arraybuffer'}).then(res=>{
            // return
            var arr = res
            var enc = new TextDecoder('utf-8')
            try {
                 var data = JSON.parse(enc.decode(new Uint8Array(arr.data)))
                 loading.close();
                 this.tip(data.message,"warning")
            } catch (error) {
                loading.close();
                func(res)
            }
        },error=>{
            this.tip(error.data.message,"warning")
        });
    }
    //采购合同导入模板下载
    Vue.prototype.exportProcureFile = function(func){
        const loading = this.$loading({
            lock: true,//lock的修改符--默认是false
            text: 'Loading',//显示在加载图标下方的加载文案
            spinner: 'el-icon-loading',//自定义加载图标类名
            background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
            target: document.querySelector('#table')//loadin覆盖的dom元素节点
        })
        axios.post("/erp/purchase.down.excel.tpl",{
            // code : type,
            // contract_no : contract_no,
            // purchase_id : purchase_id,
            // processing_id : processing_id
        },{responseType: 'arraybuffer'}).then(res=>{
            // return
            var arr = res
            var enc = new TextDecoder('utf-8')
            try {
                 var data = JSON.parse(enc.decode(new Uint8Array(arr.data)))
                 loading.close();
                 this.tip(data.message,"warning")
            } catch (error) {
                loading.close();
                func(res)
            }
        },error=>{
            this.tip(error.data.message,"warning")
        });
    }

    // 客户列表
    Vue.prototype.$getCustomerList = function(salesman_id){
        return axios.post("/erp/customer.select",{
            salesman_id : salesman_id
        })
    }

    // 销售员
    Vue.prototype.$getSalemanList = function(customer_id,obj){
        return axios.post("/erp/user.select",{
            customer_id : customer_id,
            show_disabled:obj
        })
    }

    // 银行账户
    Vue.prototype.$getBankList = function(){
        return axios.post("/erp/account.select")
    }

    // 付款方式
    Vue.prototype.$getPaymentTypeList = function(){
        return axios.post("/erp/payment.type.select")
    }

    // 品名
    Vue.prototype.$getBreedList = function(){
        return axios.post("/erp/breed.select")
    }

    // 品牌
    Vue.prototype.$getBrandList = function(){
        return axios.post("/erp/brand.select")
    }

    // 等级
    Vue.prototype.$getGradeList = function(){
        return axios.post("/erp/grade.select")
    }
    // 币种
    Vue.prototype.$getCurrencyList = function(){
        return axios.post("erp/currency.select")
    }
    // 明细仓库
    Vue.prototype.$getPurchaseWareList = function(){
        return axios.post("/erp/purchase.warehouse.select")
    }
    // 仓库
    Vue.prototype.$getWarehouseList = function(){
        return axios.post("/erp/warehouse.select")
    }

    // 供应商
    Vue.prototype.$getSupplierList = function(){
        return axios.post("/erp/supplier.select")
    }

    // 获取当月第一天00：00：00 unix
    Vue.prototype.$getCurrentMonthStartUnix = function(){
        return moment().month(window.moment().month()).date(1).hour(0).minute(0).second(0).unix();
    }

    // 获取当月最后一天23：59：59 unix
    Vue.prototype.$getCurrentMonthEndtUnix = function(){
        return moment().month(window.moment().month()).date(window.moment().daysInMonth()).hour(23).minute(59).second(59).unix();
    }

    // 获取当月第一天00：00：00 valueOF
    Vue.prototype.$getCurrentMonthStartValueOf = function(){
        return moment().month(window.moment().month()).date(1).hour(0).minute(0).second(0).valueOf();
    }

    // 获取当月最后一天23：59：59 valueOF
    Vue.prototype.$getCurrentMonthEndtValueOf = function(){
        return moment().month(window.moment().month()).date(window.moment().daysInMonth()).hour(23).minute(59).second(59).valueOf();
    }
    
    //获取一年前日期
    Vue.prototype.$getDateOneYearAgo= function(){
        return moment().subtract(1,'year').format('YYYY-MM-DD'); 
    }

    Vue.prototype.$isHasBeforeDays = function (objArr, time_field) {
        //objArr为对象二维数组
        return objArr.some(d => {
            let scheme = 'YYYY-MM-DD';
            let fmt ;//待对比字段值 的 0点0分0秒
            if (typeof d[time_field] === 'number') {
                fmt = moment.unix(d[time_field]).format(scheme);
            }else {
                fmt = moment(d[time_field]).format(scheme);
            }
            let s_time_first = fmt;
            let today_first = moment().format(scheme);//今天0点0分0秒
            let diffDays = moment(s_time_first).diff(moment(today_first), 'days');
            return diffDays < 0;
        });
    };
    //判断同一个数组里面值是否相等
    Vue.prototype.$isAllEqual = function (array){
        if(array.length>0){
           return !array.some(function(value){
             return value !== array[0];
           });   
        }else{
            return true;
        }
    }
    //高精度计算
    Vue.prototype.$bn_calc = function (_method, args) {
        if(args.length<1) return 0;
        let t = new BigNumber(args[0]);
        for (let i = 1; i < args.length; i++) {
            t = t[_method].call(t, args[i]);
        }
        return t.toNumber();
    };
    //高精度加法
    Vue.prototype.$bc_add = function () {
        return this.$bn_calc('plus', arguments);
    };
    //高精度减法
    Vue.prototype.$bc_sub = function () {
        return this.$bn_calc('minus', arguments);
    };
    //高精度乘法
    Vue.prototype.$bc_mul = function () {
        return this.$bn_calc('times', arguments);
    };
    //高精度除法
    Vue.prototype.$bc_div = function () {
        return this.$bn_calc('div', arguments);
    };
    //text 数字输入
    Vue.prototype.$digitInput = function (v, precision = 2, neq = false, sign = false) {
        // v = String(v).replace(/[^-\d+.]/g, '').replace(/(?<=\S+)[+-]/g, '').replace(/(?<!\d)\./g, '');
        v = String(v).replace(new RegExp("[^-\\d+.]",'g'),'').replace(new RegExp("(?<=\\S+)[+-]",'g'),'').replace(new RegExp("(?<!\\d)\\.","g"),'');
        if (!neq) {
            v = v.replace(/-/g, '');
        }
        if (!sign) {
            v = v.replace(/\+/g, '');
        }

        if (v.indexOf('.') !== v.lastIndexOf('.')) {
            v = v.substring(0, v.lastIndexOf('.'));
        }
        if (!isNaN(precision)) {
            if (precision === 0) {
                v = v.replace(/\./g, '');
            } else {
                // let ex1 = /(?<=\d+\.)\d+$/.exec(v);
                let ex1 = new RegExp('(?<=\\d+\\.)\\d+$').exec(v)
                if (ex1 && ex1[0].length > precision) {
                    v = v.substring(0, v.lastIndexOf('.') + precision + 1);
                }
            }
        }
        return v;
    };
      //高精度计算
      Vue.prototype.$amountTo =  function (arr, key) {
        let result = 0;
        for (let i = 0; i < arr.length; i++) {
            result += Number(arr[i][key]);// 点开看 有两个值
        }
        return result;
        
    },
    //blur事件时的数字输入
    Vue.prototype.$digitBlur = function (v, precision = 2, neq = false) {
        v = this.$digitInput(v, precision, neq);
        v = v.replace(/\.$/g, '').replace(/^[+-]$/g, '');
        return v;
    };
    //input type=number时的数字输入
    Vue.prototype.$digitInputTypeNumber = function (newVal, oldVal, errToOld = true, precision = 2) {
        let s_new = String(newVal);
        let s_old = String(oldVal);
        if (s_new === "" && s_old.includes('.')) {
            if (errToOld) newVal = s_old;
        } else {
            let ex1 = new RegExp("(?<=\\d+\\.)\\d+$").exec(s_new);
            if (ex1 && ex1[0].length > precision) {
                newVal = s_new.substring(0, s_new.lastIndexOf('.') + precision + 1);
            }
            newVal = s_new.substring(0, s_new.lastIndexOf('.') + precision + 1);
        }
        return /\.0+$/.test(newVal) ? newVal : Number(newVal);
    };

    /*克隆方法1，如果是深度引用时需要重新构建*/
    Vue.prototype.$cloneJson = function (obj,arg2,arg3) {
        return JSON.parse(JSON.stringify(obj,arg2,arg3));
    };
    /*克隆方法2，如果是深度引用时需要重新构建*/
    Vue.prototype.$deepClone = function deepClone(data) {
        const type = this.$judgeType(data);
        let obj = type === 'array' ? [] : type === 'object' ? {} : false;
        if (obj === false) return data;
        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                if (type === 'array') {
                    obj.push(this.$deepClone(data[key]));
                } else {
                    obj[key] = this.$deepClone(data[key]);
                }
            }
        }
        return obj;
    };
    /*类型判断*/
    Vue.prototype.$judgeType = function judgeType(obj) {
        const toString = Object.prototype.toString;
        const map = {
            '[object Boolean]': 'boolean',
            '[object Number]': 'number',
            '[object String]': 'string',
            '[object Function]': 'function',
            '[object Array]': 'array',
            '[object Date]': 'date',
            '[object RegExp]': 'regExp',
            '[object Undefined]': 'undefined',
            '[object Null]': 'null',
            '[object Object]': 'object',
        };
        if (obj instanceof Element) {
            return 'element';
        }
        return map[toString.call(obj)];
    };
    Vue.prototype.$changeTimeParams = function (rawParams,timeFields=[]) {
        let res = this.$cloneJson(rawParams);
        timeFields.forEach((f)=>{
            res[f] = this.formatTimeZero(res[f]);
        });
        return res;
    };
    Vue.prototype.$changeTimeRes = function (rawParams,timeFields=[]) {
        let res = this.$cloneJson(rawParams);
        timeFields.forEach((f)=>{
            res[f] = res[f] ? res[f] * 1000 : '';
        });
        return res;
    };
    /*copy 编辑表单的数据部分字段, 排除*/
    Vue.prototype.$copyEditForm = function (rawData, resData, excludeFields = [], append = false) {
        let newData = append ? this.$cloneJson(rawData) : {};
        for (let field in rawData) {
            if (rawData.hasOwnProperty(field)) {
                let isExclude = excludeFields.includes(field);//排除字段
                if (!isExclude) {
                    newData[field] = resData[field]!==undefined ? resData[field] : '';
                }
            }
        }
        return newData;
    };
    /*copy 列表数据，按原数据的字段*/
    Vue.prototype.$copyListData = function (fieldsForm, resList, excludeFields = []) {
        return resList.map(d => {
            let fields = Object.keys(fieldsForm);
            let res = {};
            fields.forEach((v) => {
                let isExclude = excludeFields.includes(v);
                if (!isExclude) {
                    res[v] = d[v];
                }
            });
            return res;
        });
    };
    /*字符串去掉最右边的字符串*/
    Vue.prototype.$trimRightStr = function (str, tobeTrimStr) {
        return str.endsWith(tobeTrimStr) ? str.substring(0, str.lastIndexOf(tobeTrimStr)) : str;
    };
    /*排序通用参数处理*/
    Vue.prototype.$generalSortParams = function (_sourceParamsObj, sortObj) {
        if (sortObj.order) {
            _sourceParamsObj['sort'] = sortObj.prop;
            _sourceParamsObj['order'] = this.$trimRightStr(sortObj.order, 'ending');
        }else{
            _sourceParamsObj['sort'] = '';
            _sourceParamsObj['order'] = '';
        }
    };
    //设置合计字段fieldsConf {field1:precision1,field2:precision2,field3:{precision:1,callback:{}}}
    Vue.prototype.$setSummaryFields = function (params, fieldsConf, callback = null) {
        const {columns, data} = params;
        const sums = [];
        let totalObj = {};
        columns.forEach((c, i) => {
            if (i === 0) {
                sums[i] = '合计';
            }
            for (let f in fieldsConf) {
                if (fieldsConf.hasOwnProperty(f)) {
                    let precision = 0;
                    let fd = fieldsConf[f];
                    if (typeof fd === "number") {
                        precision = Number(fd);
                    } else if (typeof fd === "object") {
                        precision = Number(fd.precision);
                    }
                    if (data.every(a => !isNaN(Number(a[f])))) {
                        let values = data.map(d => Number(d[f]));
                        if (values.length > 0) {
                            let _each_sum = totalObj[f] = this.$keepNumber(this.$bc_add(...values), precision);
                            if (String(c.property) === String(f)) {
                                sums[i] = _each_sum;
                            }
                            if (fd.hasOwnProperty('callback') && typeof fd.callback === "function") {
                                fd.callback(_each_sum);
                            }
                        }
                    }
                }
            }
        });
        typeof callback === "function" && callback(totalObj);
        return sums;
    };
    Vue.prototype.$keepNumber = function (number,precision) {
        let po = Math.pow(10, Number(precision));
        return Math.round(Number(number) * po) / po;
    };
    //批量删除公共方法
    Vue.prototype.deleteFunc = function (url, ids, func) {
        this.delFunc(url, {ids: ids}, func);
    };
    //单个删除
    Vue.prototype.singleDelFunc = function (url, id, func) {
        this.delFunc(url, {id: id}, func);
    };
    //删除
    Vue.prototype.delFunc = function (url, _params, func) {
        this.$confirmPost("是否确定删除?", url, _params, func);
    };
    //撤回
    Vue.prototype.recallFunc = function (url, _params, func) {
        this.$confirmPost("是否确定撤回?", url, _params, func);
    };
    //确认后再post请求
    Vue.prototype.$confirmPost = function (text, url, _params, func) {
        this.confirmLog(text, () => {
            this.postFuncLoading(url, _params, () => {
                if (func) {
                    func();
                }
            }, error => {
                this.tip(error.data.message, "warning");
            })
        });
    };
    Vue.prototype.confirmLog = function (title, confirm, cancel) {
        this.$confirm(title, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            if (confirm) {
                confirm();
            }
        }).catch(() => {
            if (cancel) {
                cancel();
            }
        });
    };
    //文件大小转换
    Vue.prototype.$fileSizeConversion=  function conver(limit){  
        var size = "";  
        if( limit < 0.1 * 1024 ){ //如果小于0.1KB转化成B  
            size = limit.toFixed(2) + "B";    
        }else if(limit < 0.1 * 1024 * 1024 ){//如果小于0.1MB转化成KB  
            size = (limit / 1024).toFixed(2) + "KB";              
        }else if(limit < 0.1 * 1024 * 1024 * 1024){ //如果小于0.1GB转化成MB  
            size = (limit / (1024 * 1024)).toFixed(2) + "MB";  
        }else{ //其他转化成GB  
            size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";  
        }    
        var sizestr = size + "";   
        var len = sizestr.indexOf("\.");  
        var dec = sizestr.substr(len + 1, 2);  
        if(dec == "00"){//当小数点后为00时 去掉小数部分  
            return sizestr.substring(0,len) + sizestr.substr(len + 3,2);  
        }  
        return sizestr;  
    }  
}
export default install;
